import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

const getPctAccent = (pct, theme) => {
  const n = Number(String(pct).replace(",", "."));
  if (n >= 25) return theme.palette.warning.main;
  if (n >= 10) return theme.palette.success.main;
  if (n >= 3) return theme.palette.info.main;
  return theme.palette.secondary.main;
};

const TotalConPct = ({
  valor,
  referencia,
  variant = "default",
  valueColor,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const isInverted = variant === "inverted";

  const formatted = Number(valor).toLocaleString("es-ES", {
    maximumFractionDigits: 2,
  });
  const pct =
    referencia !== 0
      ? ((valor / referencia) * 100).toLocaleString("es-ES", {
          maximumFractionDigits: 1,
        })
      : null;

  const accent = pct != null ? getPctAccent(pct, theme) : null;
  const amountColor =
    valueColor ??
    (isInverted
      ? theme.palette.primary.contrastText
      : theme.palette.primary.main);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 0.75,
        flexWrap: "nowrap",
      }}
    >
      <Typography
        component="span"
        sx={{
          fontWeight: 700,
          fontSize: "0.85rem",
          color: amountColor,
          lineHeight: 1.2,
        }}
      >
        {formatted}
      </Typography>
      {pct != null ? (
        <Chip
          label={`${pct}%`}
          size="small"
          sx={{
            height: 20,
            minWidth: 44,
            fontSize: "0.62rem",
            fontWeight: 800,
            letterSpacing: 0.3,
            borderRadius: 99,
            "& .MuiChip-label": { px: 0.85, py: 0 },
            ...(isInverted
              ? {
                  bgcolor: alpha(theme.palette.common.white, 0.2),
                  color: theme.palette.common.white,
                  border: `1px solid ${alpha(theme.palette.common.white, 0.38)}`,
                  boxShadow: `0 1px 4px ${alpha(theme.palette.common.black, 0.12)}`,
                }
              : {
                  bgcolor: alpha(accent, isDark ? 0.24 : 0.13),
                  color: accent,
                  border: `1px solid ${alpha(accent, 0.38)}`,
                  boxShadow: `0 1px 3px ${alpha(accent, 0.18)}`,
                }),
          }}
        />
      ) : null}
    </Box>
  );
};

export default TotalConPct;
